import TelemetryProvider from './TelemetryProvider'

export default TelemetryProvider
